module.exports = __webpack_public_path__ + "static/img/conure-double.9ee59e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/facilities/conure-double.jpg
// module id = 589
// module chunks = 0